import React from "react";
import { Card, Stack } from "@mui/material";
import { Portal } from "../../../components";
import { HeaderTitleSubtitle, ErrorMessage } from "../../../../../components";
import styles from "./notificationModal.module.css";

/**
 * Modal shell for the Create Notification flow only — scrollable body, fixed max height.
 */
function NotificationModelWrapper({
  toggleModal,
  title,
  subtitle,
  note,
  error,
  children,
}) {
  return (
    <Portal toggleModal={toggleModal}>
      <div className={styles.notificationModalShell}>
        <Card
          className={styles.notificationModalCard}
          sx={{
            display: "flex",
            flexDirection: "column",
            maxHeight: "min(90vh, 52rem)",
            minHeight: 0,
            overflow: "hidden",
          }}
          elevation={0}
        >
          <Stack spacing={0.5} className={styles.notificationModalHeader}>
            <HeaderTitleSubtitle
              title={title}
              subtitle={subtitle}
              note={note}
            />
            {error && <ErrorMessage message={error} />}
          </Stack>
          <div className={styles.notificationModalBody}>{children}</div>
        </Card>
      </div>
    </Portal>
  );
}

export default NotificationModelWrapper;
